import React, { useState, useContext, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { openUserDetail } from "redux/store/user-detail/action";
import User from "../../assets/images/userIO.svg";
import dayjs from "dayjs";
import { AuthContext } from "../../contexts/authContext";
import { useDispatch, useSelector } from "react-redux";
import { MappingAction, UserAction } from "redux/store/action";
import { Input, Select } from "antd";
import {
  DesktopOutlined,
  GlobalOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import { permissionsMap, getModuleList } from "constants/constants";
import {
  mobilePlatformProcess,
  pcPlatformProcess,
  searchUserDeviceInfoProcess,
} from "redux/store/user-device/action";
import WindowDevice from "assets/images/module-search/windows.svg";
import MacDevice from "assets/images/module-search/Mac.svg";
import LinuxDevice from "assets/images/module-search/linux.svg";
import Mobile from "assets/images/module-search/mobile.svg";
import ChromeExtension from "assets/images/module-search/chrome-extension.svg";
import Device360 from "assets/images/module-search/device-360.svg";

const Commonsearch = () => {
  const dispatch = useDispatch();
  const [searchText, setsearchText] = useState("");
  const [selectedValue, setSelectedValue] = useState("Explorer");
  const { KState, checkRequiredPermissions, getDefaultHeader } =
    useContext(AuthContext);
  const [userNodes, setuserNodes] = useState([]);
  const applicationurl = useSelector(
    // @ts-ignore
    (state) => state.mapping
  );

  const {
    user_list_success,
    user_list_data,
    user_list_failed,
    user_list_processing,
  } = useSelector(
    // @ts-ignore
    (state) => state.users
  );
  const [suggestions, setSuggestions] = useState([]);
  const [suggestionUsers, setSuggestionUsers] = useState([]);
  const [appsUrls, setAppsUrls] = useState([]);
  const [suggestionDevices, setSuggestionDevices] = useState([]);

  const navigate = useNavigate();
  const location = useLocation();
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
  const wrapperRef = useRef<HTMLDivElement>(null);
  const platformIcons = {
    WINDOWS: WindowDevice,
    MAC_OS: MacDevice,
    LINUX: LinuxDevice,
    ANDROID: Mobile,
    IOS: Mobile,
    UNKNOWN: Device360,
    BROWSER_EXT: ChromeExtension,
  };
  // Close dropdown on outside click
  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (
        wrapperRef.current &&
        !wrapperRef.current.contains(event.target as Node)
      ) {
        setIsDropdownVisible(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    setsearchText("");
    setSuggestionUsers([]);
    setSuggestions([]);
    setAppsUrls([]);
    setIsDropdownVisible(false);
    setSuggestionDevices([]);
  }, [location.pathname]);

  const getUserTreeNode = (userList) => {
    const ulist = [];
    const uName = [];
    const uIds = [];
    let id = "";
    let fullname = "";
    let email = "";
    userList.forEach((item) => {
      id = item?.identity?.id;
      fullname = item?.identity?.first_name + " " + item?.identity?.last_name;
      email = item?.identity?.email;
      uIds.push(id);
      uName.push(fullname);
      ulist.push({
        title: fullname,
        children: null,
        value: id,
        email: email,
      });
    });

    setuserNodes(ulist);
  };
  const GetUserList = () => {
    if (
      KState &&
      KState.keycloak &&
      !user_list_success &&
      !user_list_processing
    ) {
      const data = {
        headers: getDefaultHeader(),
        isOwner: checkRequiredPermissions([permissionsMap.TENANT_OWNER]),
      };

      dispatch(UserAction.UserListProcess(data));
    }
  };
  useEffect(() => {
    if (user_list_success === true) {
      if ((user_list_data || []).length > 0) {
        getUserTreeNode(user_list_data);
      } else if (user_list_failed === true) {
        setuserNodes([]);
      }
    }
  }, [user_list_success, user_list_failed, user_list_data]);

  useEffect(() => {
    GetUserList();
  }, []);
  const getBodyParameters = (mappedType, searchValue, appUrlValue) => {
    let body = {};
    if (mappedType === "all") {
      body =
        appUrlValue === "ALL"
          ? !searchValue
            ? { ilike: {} }
            : { ilike: { value: searchValue } }
          : !searchValue
          ? { ilike: { type: appUrlValue } }
          : { ilike: { value: searchValue, type: appUrlValue } };
    }
    return body;
  };
  const getDeviceBodyParameters = (searchValue) => {
    let body = {};
    body = !searchValue
      ? { ilike: {} }
      : { ilike: { machine_user: searchValue } };

    return body;
  };
  const GetApplicationUrlList = (param, body) => {
    if (KState?.keycloak && param.page > 0) {
      const data = {
        param: param,
        body: body,
        headers: getDefaultHeader(),
      };

      dispatch(MappingAction.AppilcationUrlListProcess(data));
    }
  };
  const GetUserDeviceList = (body) => {
    if (KState?.keycloak) {
      // const data = {
      //   // param: param,
      //   body: body,
      //   headers: getDefaultHeader(),
      // };
      // dispatch(searchUserDeviceInfoProcess(data)
      dispatch(
        searchUserDeviceInfoProcess({
          body: body,
          header: getDefaultHeader(),
          isOwner: checkRequiredPermissions([permissionsMap.TENANT_OWNER]),
        })
      );
    }
  };
  async function handleSearch(event) {
    const inputValue = event.target.value;
    setsearchText(inputValue);
    if (!isDropdownVisible) setIsDropdownVisible(true);

    const moduleList = await getModuleList();
    console.log("moduleList", moduleList);
    if (inputValue !== "" && selectedValue === "Explorer" && moduleList) {
      const filteredSuggestions = moduleList.filter((item) =>
        item.name.toLowerCase().includes(inputValue.toLowerCase())
      );

      setSuggestions(filteredSuggestions);
    } else if (
      inputValue !== "" &&
      selectedValue === "Apps/URLs" &&
      userNodes
    ) {
      const param = {
        page: 1,
        size: 200,
        sortBy: "id",
        direction: "desc",
      };
      const getBodyParam = getBodyParameters("all", inputValue, "ALL");
      GetApplicationUrlList(param, getBodyParam);
    } else if (inputValue !== "" && selectedValue === "Users" && userNodes) {
      const filteredSuggestionUsers = userNodes.filter((item) =>
        item.title.toLowerCase().includes(inputValue.toLowerCase())
      );
      setSuggestionUsers(filteredSuggestionUsers);
    } else if (inputValue !== "" && selectedValue === "Devices" && userNodes) {
      const param = {
        page: 1,
        size: 200,
        sortBy: "id",
        direction: "desc",
      };
      const body = {
        identity_ids: [],
        group_ids: [],
        search_query: inputValue,
      };

      GetUserDeviceList(body);
    } else {
      setSuggestions([]);
      setSuggestionUsers([]);
      setSuggestionDevices([]);
    }
  }
  const {
    search_user_device_info_data,
    search_user_device_info_success,
  }: {
    search_user_device_info_data: UserDeviceInfo[];
    search_user_device_info_success: boolean;
  } = useSelector(
    // @ts-ignore
    (state) => state.userDevice
  );

  const [devcieData, setDevcieData] = useState([]);

  useEffect(() => {
    if (
      search_user_device_info_success &&
      search_user_device_info_data.length > 0
    ) {
      setDevcieData(search_user_device_info_data);
    } else {
      setDevcieData([]);
    }
  }, [search_user_device_info_success, searchText]);
  useEffect(() => {
    if (applicationurl?.applicationurl_list_success) {
      if (applicationurl?.applicationurl_list_data?.length > 0) {
        const appUrlData = [];
        applicationurl?.applicationurl_list_data.map((item, index) => {
          const data = {
            id: item?.id,
            categoryName:
              item?.application_category === null
                ? "Unmapped"
                : item?.application_category?.name,

            appUrlName: item?.name,
            type:
              item?.type === "APPLICATION"
                ? "Apps"
                : item?.type === "URL"
                ? "URLs"
                : "",
          };

          appUrlData.push(data);
        });
        setAppsUrls(appUrlData);
      }
    }
  }, [
    applicationurl?.applicationurl_list_success,
    applicationurl?.applicationurl_list_data,
    applicationurl?.applicationurl_list_failed,
    searchText,
  ]);

  const handleSelectSuggestion = (selectedItem) => {
    setsearchText(selectedItem.name);
    setSuggestions([]);
    setIsDropdownVisible(false);
    if (selectedItem.key === "settings") {
      navigate(selectedItem.path, {
        state: { settingKey: selectedItem.id },
      });
    } else if (selectedItem.key === "reports") {
      navigate(selectedItem.path, {
        state: { id: selectedItem.id },
      });
    } else if (selectedItem.key === "helps") {
      window.open(selectedItem.path, "_blank");
    } else {
      navigate(selectedItem.path);
    }
  };
  const getmobilePlatform = () => {
    dispatch(
      mobilePlatformProcess({
        body: {
          platform: true,
          myzen: false,
          type: "mobile",
          cpu: false,
        },

        header: getDefaultHeader(),
        isOwner: checkRequiredPermissions([permissionsMap.TENANT_OWNER]),
      })
    );
  };
  const getpcPlatform = () => {
    dispatch(
      pcPlatformProcess({
        body: {
          platform: true,
          myzen: false,
          type: "pc",
          cpu: false,
        },

        header: getDefaultHeader(),
        isOwner: checkRequiredPermissions([permissionsMap.TENANT_OWNER]),
      })
    );
  };
  const handleSelectChange = (value: string) => {
    setsearchText("");
    setSelectedValue(value);
    if (value === "Devices") {
      getpcPlatform();
      getmobilePlatform();
    }
  };
  const selectAfter = (
    <Select
      defaultValue={selectedValue}
      onChange={handleSelectChange}
      style={{ width: 120 }}
      size="large"
      className="serach-common"
    >
      <Select.Option value="Explorer">Explorer</Select.Option>
      <Select.Option value="Users">Users</Select.Option>
      <Select.Option value="Apps/URLs">Apps/URLs</Select.Option>
      <Select.Option value="Devices">Devices</Select.Option>
    </Select>
  );

  const handleSelectUser = (value) => {
    const startDate = dayjs().subtract(6, "d");
    const endDate = dayjs();
    setsearchText(value.title);
    dispatch(
      openUserDetail({ identityId: value.value, tab: 0, startDate, endDate })
    );
    setSuggestionUsers([]);
    setIsDropdownVisible(false);
  };

  const handleSelectAppUrl = (value) => {
    setsearchText(value.appUrlName);
    setAppsUrls([]);
    setIsDropdownVisible(false);
    navigate("/application", {
      state: { id: "Detailed", category: value.categoryName, type: value.type },
    });
  };
  const handleSelectDevice = (value) => {
    setsearchText(value.device_username);
    setDevcieData([]);
    setIsDropdownVisible(false);

    const platform = value.platform;

    // Platform → Device type
    const pcPlatforms = ["MAC_OS", "WINDOWS", "LINUX"];
    const mobilePlatforms = ["ANDROID", "IOS", "BROWSER_EXT", "UNKNOWN"];

    let deviceType = "PC"; // default

    if (pcPlatforms.includes(platform)) {
      deviceType = "PC";
    } else if (mobilePlatforms.includes(platform)) {
      deviceType = "Mobile";
    }

    navigate("/devices", {
      state: {
        searchValue: value.device_username,
        platform: deviceType, // <-- PC / Mobile
      },
    });
  };
  return (
    <div className="relative" ref={wrapperRef}>
      <Input
        placeholder={
          selectedValue === "Explorer"
            ? "Discover it all: features, settings, reports..."
            : selectedValue === "Apps/URLs"
            ? "Search any Apps & URLs ...."
            : selectedValue === "Users"
            ? "Search Users..."
            : "Search Devices..."
        }
        size="large"
        className="header-common-width"
        value={searchText}
        onChange={handleSearch}
        onFocus={() => setIsDropdownVisible(true)}
        prefix={<SearchOutlined />}
        allowClear
        addonAfter={selectAfter}
      />
      {isDropdownVisible && searchText && (
        <>
          {selectedValue === "Explorer" && suggestions.length > 0 && (
            <ul className="common_search bg-white border-gray-200 shadow min-w-[500px] top-[40px] m-0 p-0 outline-0">
              {suggestions.map((item) => (
                <li
                  key={item.id}
                  onClick={() => handleSelectSuggestion(item)}
                  className="text-[13px] cursor-pointer text-slate-700 list-none py-[15px] flex items-center pl-[20px] border-gray-200 hover:bg-slate-200 hover:text-gray-800"
                >
                  {item?.icon && (
                    <img src={item?.icon} alt={item?.name} className="mr-3" />
                  )}
                  <div>
                    <strong>{item?.name}</strong>
                    <div className="text-gray-500">{item?.description}</div>
                  </div>
                </li>
              ))}
            </ul>
          )}
          {selectedValue === "Apps/URLs" && appsUrls.length > 0 && (
            <ul className="common_search bg-white border-gray-200 shadow min-w-[500px] top-[40px] m-0 p-0 outline-0">
              {appsUrls.map((item) => (
                <li
                  key={item.id}
                  onClick={() => handleSelectAppUrl(item)}
                  className="text-[13px] cursor-pointer text-slate-700 list-none py-[15px] flex items-center pl-[20px] border-gray-200 hover:bg-slate-200 hover:text-gray-800"
                >
                  {item?.type === "APPLICATION" ? (
                    <DesktopOutlined className="mr-3" />
                  ) : (
                    <GlobalOutlined className="mr-3" />
                  )}
                  <div>
                    <strong>{item?.appUrlName}</strong>
                    <div className="text-gray-500">{item?.categoryName}</div>
                  </div>
                </li>
              ))}
            </ul>
          )}
          {selectedValue === "Users" && suggestionUsers.length > 0 && (
            <ul className="common_search bg-white border-gray-200 shadow min-w-[500px] top-[40px] m-0 p-0 outline-0">
              {suggestionUsers &&
                suggestionUsers.map((item) => (
                  <li
                    key={item.value}
                    onClick={() => handleSelectUser(item)}
                    className="text-[13px] cursor-pointer text-slate-700 list-none py-[15px] flex items-center pl-[20px] border-gray-200 hover:bg-slate-200 hover:text-gray-800"
                  >
                    <img src={User} alt={item?.title} className="mr-3" />

                    <div>
                      <strong>{item?.title}</strong>
                      <div className="text-gray-500">{item?.email}</div>
                    </div>
                  </li>
                ))}
            </ul>
          )}
          {selectedValue === "Devices" && devcieData.length > 0 && (
            <ul className="common_search bg-white border-gray-200 shadow min-w-[500px] top-[40px] m-0 p-0 outline-0">
              {devcieData &&
                devcieData.map((item) => (
                  <li
                    key={item.id}
                    onClick={() => handleSelectDevice(item)}
                    className="text-[13px] cursor-pointer text-slate-700 list-none py-[15px] flex items-center pl-[20px] border-gray-200 hover:bg-slate-200 hover:text-gray-800"
                  >
                    <img
                      src={platformIcons[item?.platform] || Device360}
                      className="mr-3"
                    />
                    <div>
                      <strong>{item?.device_username}</strong>
                      <div className="text-gray-500">{item?.hostname}</div>

                      <div className="text-gray-500">{item?.platform}</div>
                    </div>
                  </li>
                ))}
            </ul>
          )}
        </>
      )}
    </div>
  );
};
export default Commonsearch;
